import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 16px 80px;

  @media (max-width: 600px) {
    padding: 0 0 32px;
    background: #fff;
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 720px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
  overflow: hidden;

  @media (max-width: 600px) {
    border-radius: 0;
    box-shadow: none;
  }

  /* Bigger inputs globally — senior-friendly */
  .ant-input,
  .ant-select .ant-select-selector {
    min-height: 50px !important;
    font-size: 17px !important;
    border-radius: 10px !important;
    border-color: #c8c8c8 !important;
  }

  .ant-input {
    padding: 10px 16px !important;
  }

  .ant-input::placeholder {
    color: rgba(0, 0, 0, 0.3) !important;
    font-size: 16px !important;
  }

  .ant-select .ant-select-selector {
    padding: 8px 16px !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-item {
    font-size: 17px !important;
  }

  .ant-select-selection-placeholder {
    font-size: 16px !important;
    color: rgba(0, 0, 0, 0.3) !important;
  }

  textarea.ant-input {
    min-height: 90px !important;
    padding: 14px 16px !important;
  }

  .ant-form-item-label > label {
    font-size: 15px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
  }

  .ant-form-item-explain-error {
    font-size: 14px;
    margin-top: 6px;
    color: #cf1322;
  }

  /* Focus states — more visible */
  .ant-input:focus,
  .ant-input-focused,
  .ant-select-focused .ant-select-selector {
    border-color: var(--primary, #1890ff) !important;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.15) !important;
  }

  @media (max-width: 600px) {
    .ant-input,
    .ant-select .ant-select-selector {
      min-height: 52px !important;
      font-size: 18px !important;
    }

    .ant-form-item-label > label {
      font-size: 16px;
    }
  }
`;

export const Header = styled.div`
  padding: 36px 32px 28px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;

  @media (max-width: 600px) {
    padding: 28px 20px 24px;
  }
`;

export const Logo = styled.img`
  height: 52px;
  object-fit: contain;
`;

export const TenantName = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
`;

export const ClientRow = styled.div`
  padding: 20px 32px;
  border-bottom: 1px solid #bae7ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #e6f7ff;

  @media (max-width: 600px) {
    padding: 16px 20px;
  }
`;

export const ClientLabel = styled.span`
  font-size: 13px;
  color: #1890ff;
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const ClientName = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
`;

export const NotMeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1.5px solid #d9d9d9;
  border-radius: 10px;
  background: #fff;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  flex-shrink: 0;

  .anticon {
    font-size: 14px;
  }

  &:hover {
    border-color: #ff7875;
    color: #ff4d4f;
    background: rgba(255, 77, 79, 0.04);
  }

  &:active {
    background: rgba(255, 77, 79, 0.08);
  }
`;

export const FormBody = styled.div`
  padding: 32px;

  @media (max-width: 600px) {
    padding: 24px 20px;
  }
`;

export const SectionLabel = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 14px;
  text-transform: uppercase;
  letter-spacing: 0.8px;

  @media (max-width: 600px) {
    font-size: 13px;
  }
`;

export const NfeCard = styled.div`
  background: #fafafa;
  border: 1.5px solid #e0e0e0;
  border-radius: 14px;
  padding: 24px;
  margin-bottom: 20px;
  transition: border-color 0.2s;

  &:hover {
    border-color: #c8c8c8;
  }

  @media (max-width: 600px) {
    padding: 20px 16px;
  }
`;

export const NfeCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const NfeCardTitle = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1.5px solid #e8e8e8;
  background: #fff;
  color: rgba(0, 0, 0, 0.35);
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 77, 79, 0.08);
    border-color: #ff7875;
    color: #ff4d4f;
  }

  &:active {
    background: rgba(255, 77, 79, 0.15);
  }

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const FormRow = styled.div<{ $columns?: string }>`
  display: grid;
  grid-template-columns: ${(props) => props.$columns || '1fr 1fr'};
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 56px;
  border: 2px dashed #c8c8c8;
  background: transparent;
  color: rgba(0, 0, 0, 0.55);
  font-size: 16px;
  font-weight: 600;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: var(--primary, #1890ff);
    color: var(--primary, #1890ff);
    background: rgba(24, 144, 255, 0.03);
  }

  &:active {
    background: rgba(24, 144, 255, 0.08);
  }

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const SubmitButton = styled.div`
  margin-top: 12px;

  .ant-btn {
    height: 56px !important;
    font-size: 18px !important;
    font-weight: 700 !important;
    border-radius: 14px !important;
    letter-spacing: 0.2px;
  }
`;

export const InfoBanner = styled.div`
  margin: 0 32px 32px;
  padding: 14px 18px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 10px;
  font-size: 15px;
  color: #0050b3;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  line-height: 1.5;

  a {
    font-weight: 600;
  }

  @media (max-width: 600px) {
    margin: 0 20px 24px;
    font-size: 15px;
  }
`;

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px 32px;
  text-align: center;
  gap: 20px;

  h2 {
    font-size: 24px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.85);
    margin: 0;
  }

  p {
    font-size: 17px;
    color: rgba(0, 0, 0, 0.6);
    margin: 0;
    max-width: 420px;
    line-height: 1.6;
  }

  .ant-btn {
    margin-top: 12px;
    height: 50px !important;
    font-size: 17px !important;
    font-weight: 600 !important;
    border-radius: 12px !important;
    padding: 0 40px !important;
  }
`;

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px 32px;
  text-align: center;
  gap: 16px;

  h2 {
    font-size: 22px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.85);
    margin: 0;
  }

  p {
    font-size: 17px;
    color: rgba(0, 0, 0, 0.6);
    margin: 0;
    line-height: 1.6;
  }
`;

/* ── Step Indicator ── */

export const StepIndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 32px 8px;
  gap: 0;

  @media (max-width: 600px) {
    padding: 24px 20px 8px;
  }
`;

export const StepDot = styled.div<{ $active?: boolean; $completed?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
  transition: all 0.25s;

  background: ${(props) =>
    props.$active
      ? 'var(--primary, #1890ff)'
      : props.$completed
      ? '#52c41a'
      : '#e0e0e0'};
  color: ${(props) =>
    props.$active || props.$completed ? '#fff' : 'rgba(0, 0, 0, 0.4)'};

  ${(props) => props.$active && 'box-shadow: 0 0 0 4px rgba(24, 144, 255, 0.18);'}
`;

export const StepLine = styled.div<{ $completed?: boolean }>`
  width: 56px;
  height: 3px;
  border-radius: 2px;
  transition: background 0.25s;
  background: ${(props) => (props.$completed ? '#52c41a' : '#e0e0e0')};

  @media (max-width: 600px) {
    width: 40px;
  }
`;

export const StepLabel = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  padding: 4px 32px 20px;
`;

/* ── Type Cards (Step 2) ── */

export const TypeCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0 16px;
`;

export const TypeCard = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding: 28px 24px;
  border: 2px solid ${(props) => (props.$disabled ? '#f0f0f0' : '#e0e0e0')};
  border-radius: 16px;
  background: ${(props) => (props.$disabled ? '#fafafa' : '#fff')};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  text-align: left;
  transition: all 0.2s;

  &:hover {
    ${(props) =>
      !props.$disabled &&
      `
      border-color: var(--primary, #1890ff);
      background: rgba(24, 144, 255, 0.02);
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.08);
    `}
  }

  &:active {
    ${(props) =>
      !props.$disabled &&
      `
      background: rgba(24, 144, 255, 0.06);
      transform: scale(0.99);
    `}
  }

  @media (max-width: 600px) {
    padding: 24px 20px;
    gap: 16px;
  }
`;

export const TypeCardWarning = styled.div`
  margin-top: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #d48806;
  line-height: 1.4;
`;

export const TypeCardIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 14px;
  background: #f0f5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--primary, #1890ff);

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const TypeCardContent = styled.div`
  flex: 1;
`;

export const TypeCardTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 6px;
`;

export const TypeCardSubtitle = styled.div`
  font-size: 15px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.5;
`;

export const TypeCardArrow = styled.div`
  color: rgba(0, 0, 0, 0.25);
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;
  }
`;

/* ── Back Button ── */

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  color: rgba(0, 0, 0, 0.55);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 4px;
  margin-bottom: 20px;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    color: rgba(0, 0, 0, 0.8);
    background: rgba(0, 0, 0, 0.04);
  }

  &:active {
    background: rgba(0, 0, 0, 0.07);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

/* ── Upload Area ── */

export const UploadArea = styled.div`
  .ant-upload-drag {
    border-radius: 16px !important;
    border: 2px dashed #c8c8c8 !important;
    background: #fafafa !important;
    padding: 48px 24px !important;
    transition: all 0.2s !important;

    &:hover {
      border-color: var(--primary, #1890ff) !important;
      background: rgba(24, 144, 255, 0.02) !important;
    }
  }

  .ant-upload-drag-icon {
    margin-bottom: 16px !important;

    svg {
      width: 56px;
      height: 56px;
      color: var(--primary, #1890ff);
    }
  }

  .ant-upload-text {
    font-size: 18px !important;
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.75) !important;
  }

  .ant-upload-hint {
    font-size: 15px !important;
    color: rgba(0, 0, 0, 0.5) !important;
    margin-top: 4px !important;
  }
`;

/* ── Step Title ── */

export const StepTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.88);
  margin: 0 0 6px;

  @media (max-width: 600px) {
    font-size: 22px;
  }
`;

export const StepSubtitle = styled.p`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  margin: 0 0 28px;
  line-height: 1.5;
`;

/* ── Info Tooltip Icon ── */

export const InfoIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-left: 6px;
  color: rgba(0, 0, 0, 0.3);
  cursor: help;
  vertical-align: middle;
  transition: color 0.2s;

  &:hover {
    color: var(--primary, #1890ff);
  }

  .anticon {
    font-size: 14px;
  }
`;

/* ── Footer ── */

export const PoweredBy = styled.div`
  margin-top: 24px;
  text-align: center;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.3);

  a {
    color: rgba(0, 0, 0, 0.45);
    font-weight: 600;
    text-decoration: none;

    &:hover {
      color: rgba(0, 0, 0, 0.65);
    }
  }
`;
